function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var crypto = require('crypto');
var _require = require('saito-js/lib/util'),
  fromBase58 = _require.fromBase58;
var _require2 = require('saito-js/lib/transaction'),
  TransactionType = _require2.TransactionType;
var Transaction = require('saito-js/lib/transaction')["default"];
var Slip = require('saito-js/lib/slip')["default"];
var _require3 = require('./manual-production-log'),
  logManualProduction = _require3.logManualProduction;
var MINING_YIELD_INTERVAL = 1000;
function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
function leadingZeroBits(hashHex) {
  var bytes = Buffer.from(hashHex, 'hex');
  var value = 0n;
  for (var i = 0; i < bytes.length; i++) {
    value = value << 8n | BigInt(bytes[i]);
  }
  if (value === 0n) {
    return 256;
  }
  var bits = 0;
  for (var _i = 255; _i >= 0; _i--) {
    if ((value & 1n << BigInt(_i)) !== 0n) {
      break;
    }
    bits++;
  }
  return bits;
}
function serializeGoldenTicket(targetHex, randomHex, publicKeyBase58) {
  var target = Buffer.from(targetHex, 'hex');
  var random = Buffer.from(randomHex, 'hex');
  var publicKey = Buffer.from(fromBase58(publicKeyBase58), 'hex');
  return Buffer.concat([target, random, publicKey]);
}
function createGoldenTicketTransaction(_x, _x2) {
  return _createGoldenTicketTransaction.apply(this, arguments);
}
/**
 * Mine exactly one golden ticket for the current chain tip and propagate it.
 */
function _createGoldenTicketTransaction() {
  _createGoldenTicketTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, goldenTicketBytes) {
    var publicKey, tx, input, output;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return app.wallet.getPublicKey();
        case 1:
          publicKey = _context.v;
          tx = new Transaction();
          tx.type = TransactionType.GoldenTicket;
          tx.data = new Uint8Array(goldenTicketBytes);
          input = new Slip();
          input.publicKey = publicKey;
          input.amount = 0n;
          input.blockId = 0n;
          input.txOrdinal = 0n;
          output = new Slip();
          output.publicKey = publicKey;
          output.amount = 0n;
          output.blockId = 0n;
          output.txOrdinal = 0n;
          tx.addFromSlip(input);
          tx.addToSlip(output);
          tx.generateHashForSignature();
          _context.n = 2;
          return tx.instance.sign();
        case 2:
          return _context.a(2, tx);
      }
    }, _callee);
  }));
  return _createGoldenTicketTransaction.apply(this, arguments);
}
function mineAndSubmitOneGoldenTicket(_x3) {
  return _mineAndSubmitOneGoldenTicket.apply(this, arguments);
}
function _mineAndSubmitOneGoldenTicket() {
  _mineAndSubmitOneGoldenTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
    var deadlineMs,
      blocks,
      latest,
      targetHex,
      difficulty,
      publicKey,
      attempts,
      randomBytes,
      randomHex,
      goldenTicketBytes,
      solutionHash,
      tx,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          deadlineMs = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : Date.now() + 600000;
          _context2.n = 1;
          return app.core.blockchain.getBlocks(1, false);
        case 1:
          blocks = _context2.v;
          latest = Array.isArray(blocks) && blocks.length ? blocks[0] : null;
          if (latest !== null && latest !== void 0 && latest.hash) {
            _context2.n = 2;
            break;
          }
          throw new Error('Explorer: cannot mine golden ticket without a chain tip');
        case 2:
          targetHex = String(latest.hash);
          difficulty = Number(latest.difficulty);
          if (!(!Number.isFinite(difficulty) || difficulty < 0)) {
            _context2.n = 3;
            break;
          }
          throw new Error('Explorer: invalid golden ticket difficulty');
        case 3:
          _context2.n = 4;
          return app.wallet.getPublicKey();
        case 4:
          publicKey = _context2.v;
          attempts = 0;
        case 5:
          if (!(Date.now() < deadlineMs)) {
            _context2.n = 10;
            break;
          }
          randomBytes = crypto.randomBytes(32);
          randomHex = app.crypto.hash(randomBytes);
          goldenTicketBytes = serializeGoldenTicket(targetHex, randomHex, publicKey);
          solutionHash = app.crypto.hash(goldenTicketBytes);
          if (!(leadingZeroBits(solutionHash) >= difficulty)) {
            _context2.n = 8;
            break;
          }
          logManualProduction("GT found after ".concat(attempts, " attempts (target=").concat(targetHex.slice(0, 16), "...)"));
          logManualProduction('GT transaction created');
          _context2.n = 6;
          return createGoldenTicketTransaction(app, goldenTicketBytes);
        case 6:
          tx = _context2.v;
          logManualProduction('GT transaction submitted to network');
          _context2.n = 7;
          return app.network.propagateTransaction(tx);
        case 7:
          logManualProduction('Mining completed — golden ticket propagated');
          return _context2.a(2, tx);
        case 8:
          attempts++;
          if (!(attempts % MINING_YIELD_INTERVAL === 0)) {
            _context2.n = 9;
            break;
          }
          _context2.n = 9;
          return sleep(0);
        case 9:
          _context2.n = 5;
          break;
        case 10:
          throw new Error('Explorer: golden ticket mining timed out');
        case 11:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _mineAndSubmitOneGoldenTicket.apply(this, arguments);
}
module.exports = {
  mineAndSubmitOneGoldenTicket: mineAndSubmitOneGoldenTicket
};